import { createServiceFactory } from '@/services/factory'
import { createMockReminderService } from './reminders.mock'
import { createHttpReminderService } from './reminders.http'

export type { ReminderService } from './reminders.service'

export const getReminderService = createServiceFactory(
  'reminders',
  createMockReminderService,
  createHttpReminderService
)
